import React, { useEffect, useState } from 'react';
import {
  Button,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material';
import { getRawTimeMappings, updateRawTimeMapping } from './api';

export default function RawTimeMappings() {
  const [event, setEvent] = useState({});
  const [systems, setSystems] = useState([]);
  const [timers, setTimers] = useState([]);
  const [mappings, setMappings] = useState({});
  const [saving, setSaving] = useState({});
  const [status, setStatus] = useState('');

  const loadMappings = () => {
    getRawTimeMappings()
      .then((data) => {
        setEvent(data.event || {});
        setSystems(Array.isArray(data.systems) ? data.systems : []);
        setTimers(Array.isArray(data.timers) ? data.timers : []);
        setMappings(data.mappings || {});
      })
      .catch(() => setStatus('Unable to load raw time mappings'));
  };

  useEffect(() => {
    loadMappings();
  }, []);

  const saveMapping = (system, splits) => {
    setMappings((current) => ({ ...current, [system]: splits }));
    setSaving((current) => ({ ...current, [system]: true }));
    setStatus('');

    updateRawTimeMapping(system, splits)
      .then((data) => {
        if (!data || data.success !== true) {
          setStatus(data && data.error ? data.error : 'Unable to save mapping');
        }
      })
      .catch(() => setStatus('Unable to save mapping'))
      .finally(() => {
        setSaving((current) => ({ ...current, [system]: false }));
      });
  };

  return (
    <div className="raw-times-page">
      <div className="raw-times-header">
        <div>
          <h2>Raw Time Mappings</h2>
          <Typography variant="caption">
            Event {event && event.event_id ? event.event_id : ''} {event && event.name ? `- ${event.name}` : ''}
          </Typography>
        </div>
        <Button variant="outlined" onClick={loadMappings}>
          Refresh
        </Button>
      </div>

      {status && <div className="raw-times-status">{status}</div>}

      <TableContainer>
        <Table size="small">
          <TableBody>
            <TableRow>
              <TableCell>System</TableCell>
              <TableCell>Split</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
            {systems.map((system) => (
              <TableRow key={system}>
                <TableCell>{system}</TableCell>
                <TableCell>
                  <Select
                    size="small"
                    value={mappings[system] || ''}
                    displayEmpty
                    onChange={(event) => saveMapping(system, event.target.value)}
                    sx={{ minWidth: 220 }}
                  >
                    <MenuItem value="" disabled>
                      Select split
                    </MenuItem>
                    {timers.map((timer) => (
                      <MenuItem key={timer} value={timer}>
                        {timer}
                      </MenuItem>
                    ))}
                  </Select>
                </TableCell>
                <TableCell>{saving[system] ? 'Saving' : mappings[system] ? 'Mapped' : 'Unmapped'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
